<section class="panel data-table">
  <div #container class="widget-content">
    <div *ngIf="!loading && (data?.rows == undefined || data?.rows.length == 0)" class="arrears-chart-no-data-message">
      <h4>No data to display</h4>
    </div>
    <p-table #dt
             exportFilename="export"
             [value]="data?.rows"
             [columns]="getColumns( data )"
             [pageLinks]="3"
             responsiveLayout="scroll"
             [resizableColumns]="true"
             [(selection)]="selectedRow"
             selectionMode="single"
             sortMode="single"
             [scrollable]="true"
             scrollHeight="flex"
             columnResizeMode="expand"
             frozenWidth="150px">
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style.width]="getColSize(col.width)">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <ng-container *ngIf="isMobile(); else desktop">
          <tr (touchMove)="headerTouched($event)" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="columnsReordered($event)">
            <th cdkDrag *ngFor="let col of columns" [hidden]="col.isSystemColumn" [pSortableColumn]="col.field" pResizableColumn pReorderableColumn pFrozenColumn [frozen]="col.isFrozen">
              {{prepareColumnName(col.header)}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
          </tr>
        </ng-container>
        <ng-template #desktop>
          <tr>
            <th *ngFor="let col of columns" [hidden]="col.isSystemColumn" [pSortableColumn]="col.field" pResizableColumn pReorderableColumn pFrozenColumn [frozen]="col.isFrozen">
              {{prepareColumnName(col.header)}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns" [hidden]="col.isSystemColumn" class="ui-resizable-column" [class.right]="isNumber(rowData[col.field])" pFrozenColumn [frozen]="col.isFrozen">
            <ng-container *ngIf="isNumber(rowData[col.field])">{{rowData[col.field]  | number:'1.2-2' }}</ng-container>
            <ng-container *ngIf="!isNumber(rowData[col.field])">{{prepareFieldData(rowData,rowData[col.field])}}</ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer" let-columns>
        <tr>
          <td *ngFor="let col of columns; let colno = index" [class.right]="colno > 0">
            <ng-template #totalCol>{{totalRow[col.field]  | number:'1.2-2'}}</ng-template>
            <span *ngIf="colno == 0 else totalCol">Total ({{currencySymbol}})</span>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
  </section>
